import React from 'react';
import styled from 'styled-components';
import { Spinner } from './Spinner';
import { useTranslation } from 'react-i18next';

const StyledFullscreenLoading = styled.div`
    left: 0;
    top: 0;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: rgba(164, 164, 164, 0.66);
    backdrop-filter: blur(2px) grayscale(0.4);
    z-index: 6000;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const FullScreenLoading = () => {
    const { t } = useTranslation();

    return (
        <StyledFullscreenLoading>
            <Spinner />
            <div>{t('LOADING_LAYOUT')}</div>
        </StyledFullscreenLoading>
    );
};
